import { useEffect, useRef } from 'react';

export default function useTimeout(
  cb = () => {},
  delay = 1000,
) {
  const handler = useRef(cb);

  useEffect(() => {
    handler.current = cb;
  }, [cb]);

  useEffect(() => {
    const t = setTimeout(() => handler.current(), delay);

    return () => {
      clearTimeout(t);
    };
  }, []);
}
